import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EmailDTO } from '@iota/iota-management-portal-v4-client';
import { ContactInformationTypeDescription, ContactInformationTypes } from '../../constants-and-enums/contact-information-type';
import { deepCopy } from '../../constants-and-enums/default-objects';

@Component({
    standalone: false,
    selector: 'app-email',
    templateUrl: './email.component.html',
    styleUrls: ['./email.component.scss']
})
export class EmailComponent implements OnInit {
    contactInformationTypes = ContactInformationTypes;
    editMode = false;

    @Input() private email: EmailDTO;
    updatedEmail: EmailDTO;

    @Output() delete: EventEmitter<EmailDTO> = new EventEmitter();
    @Output() save: EventEmitter<EmailDTO> = new EventEmitter();
    @Output() cancelEdit: EventEmitter<EmailDTO> = new EventEmitter();

    ngOnInit(): void {
        this.updatedEmail = deepCopy(this.email);
        if (!this.updatedEmail.emailId && !this.email.email) {
            this.editMode = true;
        }
    }

    getContactInformationTypeDescription(contactInformationType: string) {
        return ContactInformationTypeDescription.get(contactInformationType);
    }

    cancelEditing(): void {
        this.updatedEmail = deepCopy(this.email);
        this.cancelEdit.emit(this.email);
    }

    saveEmail(): void {
        this.save.emit(this.getUpdatedEmail());
        this.editMode = false;
    }

    getUpdatedEmail(): EmailDTO {
        return this.updatedEmail;
    }
}
